import { Base64 } from "./../../lib/helpers/utils";

export interface ProductInfo {
    ancho: string;
    perfil: string;
    llanta: string;
    carga: string;
    velocidad: string;
    agrupacionOrden: number;
    agarre: string;
    categoria: string;
    codigo: string;
    codigoMS: string;
    consumo: string;
    ruido: string;
    onda: string;
    protector: boolean;
    sealInside: boolean;
    ean: string;
    allseasons: boolean;
    estructura: string;
    etiquetado: string;
    etiquetado2: string;
    gama: string;
    imagenarticulo: string;
    imagenarticulobig: string;
    imagenmarca: string;
    invierno: boolean;
    verano: boolean;
    marca: string;
    modelo: string;
    nombre: string;
    pmc: number;
    posicion: string;
    pvr: number;
    referenciaProveedor: string;
    runflat: boolean;
    tipo: string;
    unidadMedida: number;
    uso: string;
    descripcionHtml: string;
    descripcion: string;
    obsoleto: boolean;
    homologacion: string;

    codigoqr: string;
    nieve: boolean;
    hielo: boolean;
    veretiquetado: boolean;

    electrico: boolean;
    semiSlick: boolean;
}

export class ProductInfoHelper {
    static create(obj: Object = {}): ProductInfo {
        const ini = {
            ancho: "",
            perfil: "",
            llanta: "",
            carga: "",
            velocidad: "",
            agrupacionOrden: 0,
            agarre: "",
            categoria: "",
            codigo: "",
            codigoMS: "",
            consumo: "",
            ruido: "",
            onda: "",
            protector: false,
            sealInside: false,
            ean: "",
            allseasons: false,
            estructura: "",
            etiquetado: "",
            etiquetado2: "",
            gama: "",
            imagenarticulo: "",
            imagenarticulobig: "",
            imagenmarca: "",
            invierno: false,
            verano: false,
            marca: "",
            modelo: "",
            nombre: "",
            pmc: 0,
            posicion: "",
            pvr: 0,
            referenciaProveedor: "",
            runflat: false,
            tipo: "",
            unidadMedida: 0,
            uso: "",
            descripcionHtml: "",
            descripcion: "",
            obsoleto: false,
            homologacion: '',
            codigoqr: '',
            nieve: false,
            hielo: false,
            veretiquetado: false,
            electrico: false,
            semiSlick: false,
        };

        return Object.assign(ini, obj);
    }

    static transformFromApi(apiData: Object, environment): ProductInfo {
        /*ARTEXTINGUIR: "N"
CODIGO: "0123030250003"
COM: 0
DESCRIPCION: "160/70X17 AVON 3D XM AV66 79VR"
DTO: 0
EAN: 29142806585
ETIQUETADO: ",,,"
FACTOR2: 0
FACTOR3: 0
FORMATO: "AT  "
HTML_DESCRIP: "PHA+PC9wPjxkaXY+PHN0cm9uZz5BbHRvIHJlbmRpbWllbnRvIGNvbiBtJmFhY3V0ZTtzIGVsIGtpbG9tZXRyYWplPC9zdHJvbmc+PC9kaXY+CjxkaXY+Cjx1bD4KPGxpPk5ldW0mYWFjdXRlO3RpY29zIGRlIGFsdG8gcmVuZGltaWVudG8sIGNvbiBtJmFhY3V0ZTtzIGVsIGtpbG9tZXRyYWplPC9saT4KPGxpPkxhIG51ZXZhIHZlcnNpJm9hY3V0ZTtuIFgtTSBwcm9wb3JjaW9uYSBlbnRyZSB1biAxNSUgeSB1biAyMCUgZGUga2lsb21ldHJhamUgZXh0cmEgZW4gY29tcGFyYWNpJm9hY3V0ZTtuIGNvbiBsYSBhbnRlcmlvciBnYW1hIFN0b3JtLjwvbGk+CjxsaT5JbnRyb2R1Y2UgdHJlcyBwdW50b3MgZGltZW5zaW9uYWxlcyBvY3VsdG9zIGVuIGxvcyBjb3J0ZXMgZGUgZHJlbmFqZSBwYXJhIG1lam9yYXIgbGEgZXN0YWJpbGlkYWQgeSBlbCBhZ2FycmUsIGxpbWl0YXIgbGEgZmxleGkmb2FjdXRlO24gZGUgbGEgYmFuZGEgZGUgcm9kYWR1cmEgeSBwZXJtaXRpciBxdWUgZWwgbmV1bSZhYWN1dGU7dGljbyBzZSBjYWxpZW50ZSByJmFhY3V0ZTtwaWRhbWVudGUgKDNEIFNpcGVzKS48L2xpPgo8bGk+QWx0byByZW5kaW1pZW50byAmdWFjdXRlO25pY28gZ3JhY2lhcyBhIHN1IG11bHRpY29tcHVlc3RvIHMmdWFjdXRlO3BlciByaWNvIGRlIGNhdWNobyBjb24gcyZpYWN1dGU7bGljZSwgcXVlIG1lam9yYSBlbCBhZ2FycmUgZW4gbW9qYWRvIChTUlMpLjwvbGk+CjxsaT5NYWduJmlhY3V0ZTtmaWNhcyBwcmVzdGFjaW9uZXMgZGUgbWFuZWpvIHkgZXN0YWJpbGlkYWQsIHVzYWRhcyBmcmVjdWVudGVtZW50ZSBwYXJhOiBTdXp1a2kgSGF5YWJ1c2EsIEhvbmRhIEJsYWNrYmlyZCwgS2F3YXNha2kgR1RSIDE0MDAsIFN1enVraSBHU1gxNDAwLjwvbGk+CjwvdWw+CjwvZGl2Pgk8cD48L3A+CgkJCQ=="
IMAGEN_ARTICULOBIG: "~/flex/images/articulosBIG/8861.jpg"
IMAGEN_MARCA: "http://lb.gruposoledad.net/flex/images/marcas/avon.png"
IVACOMPRAS: "1 21.00"
IVAVENTAS: "1 21.00"
LLANTA: ""
MARCA: "AVON                "
MODELO: "Storm 3D X-M AV66   "
PICTURE: ""
PLAIN_DESCRIP: ""
PRECIO: 0
RAPPELL: 0
REFCOSTES: 0
REFPROV: "4220017      "
SERIE: ""
TIPOABC: " "
TIPOART: "S"
TIPORAPPELL: 0
ULTPRECOMPRA: 69
UNIDADMEDIDA1: "1 UNIDAD"
UNIDADMEDIDA2: "0 "
UNIDADMEDIDA3: "0 "
VELOCIDAD: ""*/

        // productInfo Creation
        const productInfo = ProductInfoHelper.create();

        productInfo.llanta = apiData["LLANTA"] ? apiData["LLANTA"] : "";
        productInfo.codigo = apiData["CODIGO"] ? apiData["CODIGO"] : "";
        productInfo.ean = apiData["EAN"] ? apiData["EAN"] : "";
        productInfo.imagenarticulobig = apiData["IMAGEN_ARTICULOBIG"]
            ? apiData["IMAGEN_ARTICULOBIG"]
            : "";
        productInfo.descripcionHtml = apiData["HTML_DESCRIP"]
            ? Base64.decode(apiData["HTML_DESCRIP"])
            : "";
        productInfo.descripcion = apiData["DESCRIPCION"]
            ? apiData["DESCRIPCION"]
            : "";

        /*
        perfil: '',
        llanta: '',
        carga: '',
        velocidad: '',
        agrupacionOrden: 0,
        agarre: '',
        categoria: '',
        codigo: '',
        codigoMS: '',
        consumo: '',
        ruido: '',
        onda: 0,
        protector: false,
        ean: '',
        allseasons: false,
        estructura: '',
        etiquetado: '',
        etiquetado2: '',
        gama: '',
        imagenarticulo: '',
        imagenarticulobig: '',
        imagenmarca: '',
        invierno: false,
        verano: false,
        marca: '',
        modelo: '',
        nombre: '',
        pmc: 0,
        posicion: '',
        pvr: 0,
        referenciaProveedor: '',
        runflat: false,
        tipo: '',
        unidadMedida: 0,
        uso: '',*/

        return productInfo;
    }
}
